import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import FeatherIcon from 'feather-icons-react';
import PrivateSettingsEditPopup from 'pages/settings/private/PrivateSettingsEditPopup';
import { useState } from 'react';
import { Dropdown, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const tableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row: { original } }) => {
      const { name, id } = original;
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link to={'#'} className="fs-8 fw-bold">
              {name}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'text-break ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'value',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>Value</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { value } = original;
      return <span>{value}</span>;
    },
    meta: {
      headerProps: {
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className: 'text-break fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'description',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>Description</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { description } = original;
      return <span>{description}</span>;
    },
    meta: {
      headerProps: {
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className: 'text-break fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    id: 'actions',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Actions</span>
        </div>
      );
    },
    cell: ({ row: { original }, table }: any) => {
      const { getList } = table.options.meta;
      const [show, setShow] = useState(false);
      const [showEditModal, setShowEditModal] = useState(false);

      const handleClose = () => setShow(false);

      const handleCloseEditModal = () => {
        setShowEditModal(false);
        getList();
      };

      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              <Dropdown.Item onClick={() => setShowEditModal(true)}>
                Edit
              </Dropdown.Item>
            </RevealDropdown>
          </RevealDropdownTrigger>

          <Modal
            show={showEditModal}
            onHide={handleCloseEditModal}
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <Modal.Header>
              <Modal.Title>Edit Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <PrivateSettingsEditPopup
                handleCloseEditModal={handleCloseEditModal}
                settingsID={original.id}
              />
            </Modal.Body>
          </Modal>
        </>
      );
    },
    meta: {
      headerProps: {
        style: { width: '10%' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      },
      cellProps: {
        style: { width: '10%' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      }
    }
  }
];

const PrivateSettingsTable = () => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        tableProps={{
          className: 'phoenix-table fs-9',
          style: { width: '100%' }
        }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default PrivateSettingsTable;
